import { useContext } from 'react';
import { ToastContext } from '../Contexts/contexts';

function useToast() {
	const toastContext = useContext(ToastContext);

	const enqueueToast = (message, options) => {
		return toastContext.enqueueToast(message, options);
	};

	return enqueueToast;
}

export default useToast;
